import ActivityTypesEdit from './ActivityTypesEdit';

export default ActivityTypesEdit;
